import awsdk from "awsdk";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { List } from "/component/base";
import LoadingSkeleton from "/component/partial/LoadingSkeleton";
import { useDocumentsContext } from "/component/provider/DocumentsProvider/DocumentsProvider";
import { useAnalytics } from "/hook/useAnalytics/useAnalytics";
import { parsePersistentMessageId } from "/util/awsdk.util";

import { DocsWrapper, ListContainer } from "../DocumentsB2C.styles";
import DocumentListItem from "./DocumentListItem";
import DocumentsEmptyState from "./DocumentsEmptyState";
import DocumentsErrorState from "./DocumentsErrorState";

const DocumentsVideo = () => {
  const history = useHistory();
  const { recordAnalyticsEvent } = useAnalytics();
  const {
    videoData: data,
    videoDocs: documents,
    videoError: error,
    loadingVideoDocs: loading,
  } = useDocumentsContext();

  const senderName = "CityMD Clinical Staff";
  const showEmptyState = (data?.total || 0) <= 0;

  useEffect(() => {
    if (!loading) {
      recordAnalyticsEvent("viewDocuments", { noData: showEmptyState });
    }
  }, [recordAnalyticsEvent, showEmptyState, loading]);

  const handlePressDocument = (message: awsdk.AWSDKInboxMessage) => {
    const messageId = parsePersistentMessageId(message.id.persistentId);
    const targetUrl = `/account/messages/${messageId}`;

    history.push(targetUrl);
  };

  if (loading) return <LoadingSkeleton skeletonVariant="list-item" />;

  if (error) {
    return <DocumentsErrorState />;
  }

  if (showEmptyState) {
    return <DocumentsEmptyState />;
  }

  return (
    <DocsWrapper>
      <ListContainer>
        <List
          as="Buttons"
          chevronVariant="grey"
          hideLastChildBorder
          onClick={handlePressDocument}
          data={documents || []}
          renderItem={(message) => (
            <DocumentListItem
              title={message.subject || "Untitled"}
              providerName={senderName}
              dateString={new Date(message.date).toISOString()}
              unread={message.isUnread}
            />
          )}
        />
      </ListContainer>
    </DocsWrapper>
  );
};

export default DocumentsVideo;
